module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAaElEQVQoU52QwQ1AQBRE30ioTmhAFQqQjQaoxE0LNOMokdjEF5u4Oayd+5v3/4jEKJEjCsw7G31Gi9P1iqLAojPDmM6dhkHHA8eDgInFixqnTaHtX+azV/nPCKvPqIIxRpb8Y/KqX1fdrAstC9vIqdkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/about_btn_see.png
// module id = TDpW
// module chunks = 1